function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgKm = function SvgKm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M29.5 16c0 7.456-6.044 13.5-13.5 13.5S2.5 23.456 2.5 16 8.544 2.5 16 2.5 29.5 8.544 29.5 16zm-1 0c0-6.904-5.596-12.5-12.5-12.5S3.5 9.096 3.5 16 9.096 28.5 16 28.5 28.5 22.904 28.5 16zm-17.93 9.619l1.367-1.625a.339.339 0 01.26-.12h7.606c.1 0 .195.044.26.12l1.368 1.625a.5.5 0 10.765-.644l-1.368-1.625a1.339 1.339 0 00-1.025-.476h-7.606c-.395 0-.77.174-1.025.476l-1.368 1.625a.5.5 0 10.765.644zM15.5 6.355a.5.5 0 111 0v1.258a.5.5 0 11-1 0V6.355zM24.387 16.5a.5.5 0 110-1h1.258a.5.5 0 110 1h-1.258zm-18.032 0a.5.5 0 110-1h1.258a.5.5 0 110 1H6.355zm17.158-4.26a.5.5 0 01-.5-.867l1.09-.629a.5.5 0 11.5.866l-1.09.63zM7.897 21.256a.5.5 0 11-.5-.866l1.09-.63a.5.5 0 11.5.867l-1.09.629zm4.342-12.77a.5.5 0 11-.866.5l-.629-1.089a.5.5 0 01.866-.5l.63 1.09zm-3.252 2.887a.5.5 0 01-.5.867l-1.09-.63a.5.5 0 11.5-.866l1.09.63zm15.616 9.017a.5.5 0 11-.5.866l-1.09-.63a.5.5 0 01.5-.866l1.09.63zm-7.736-6.892l3.523-6.1c.333-.578 1.199-.078.866.5l-2.001 3.465-1.522 2.636a2.647 2.647 0 01-2.6 4.503l-.48.83c-.332.577-1.199.077-.865-.5l.48-.831a2.647 2.647 0 012.6-4.502zm.68 2.502a1.547 1.547 0 10-3.094 0 1.547 1.547 0 003.094 0z"
  }));
};
SvgKm.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgKm.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgKm;